import React from "react";
import {KatCard, KatBadge, KatAlert, KatIcon} from "@amzn/katal-react";
import {getProgramBenfit, getProgramName, programNotesMap} from "src/config/Config";
import get from "lodash/get";
import {WithTranslation, withTranslation} from "react-i18next";

interface ProgramInfoProps {
    readonly program: string,
    readonly recommendInfo?: string,
    readonly recommended: boolean,
}

type Props = ProgramInfoProps & WithTranslation;

export class ProgramInfoComponent extends React.Component<Props, {}> {

    generateRecommendationContent() {
        const {t, recommendInfo} = this.props;
        return (
            <>
                <div slot="action" className="program-info-card-recommended">
                    <KatBadge label={t('SC_FBA_Calc_badge_recommended')} type="info" variant="angled"/>
                </div>
                <KatAlert slot="subtitle" className="program-info-card-recommend-info" description={recommendInfo}
                          persistent
                          variant="info"/>
            </>
        );
    }


    render() {
        const notes = get(programNotesMap, this.props.program, "");
        const programName = getProgramName(this.props.program);
        const {t} = this.props;
        return (
            <>
                <div className="program-info-card">
                    <KatCard className="program-info-card">
                        <span slot="title" className="program-info-card-title">{t(programName)}</span>
                        {this.props.recommended && this.generateRecommendationContent()}
                        <div className="program-info-card-body">
                            <p>{t(notes)}</p>
                            {
                                getProgramBenfit(this.props.program).map((benefit, index) => (
                                    <div key={index}>
                                        <p>
                                            <KatIcon name="checkmark" size="tiny"/>{t(benefit)}
                                        </p>
                                    </div>
                                ))
                            }
                        </div>
                    </KatCard>
                </div>
            </>
        );
    }
};

export default withTranslation()(ProgramInfoComponent);
